module.exports = __webpack_public_path__ + "k-icons.1627912371871.woff2";